/* fcc-product.js — refine long, pipe-separated product titles on the PDP.
   Progressive enhancement: if JS is off, the full native title still shows. */
(function () {
  function refine() {
    var main = document.querySelector('main[data-template^="product"]');
    if (!main) return;
    var t = main.querySelector('h1');
    if (!t || t.dataset.fccPt) return;
    var raw = (t.textContent || '').trim();
    if (raw.indexOf('|') === -1) return;
    var parts = raw.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    if (parts.length < 2) return;
    var head = parts.shift();
    t.dataset.fccPt = '1';
    t.classList.add('fcc-pt');
    var mainSpan = document.createElement('span');
    mainSpan.className = 'fcc-pt-main';
    mainSpan.textContent = head;
    var subSpan = document.createElement('span');
    subSpan.className = 'fcc-pt-sub';
    subSpan.textContent = parts.join('  ·  ');
    t.textContent = '';
    t.appendChild(mainSpan);
    t.appendChild(subSpan);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refine);
  } else {
    refine();
  }
})();
